import { SpecialHoursBadge } from '../SpecialHoursBadge';

// Pure list of time-slot rows. Urgency-pill thresholds, sold-out/selected state,
// and pricing are all precomputed by the parent (BookingCalendar) — this stays
// presentational so the day-pass and tour flows can share one implementation.
export function SlotList({ slots, emptyLabel }) {
  if (slots.length === 0) {
    return <div className="mc-no-slots">{emptyLabel}</div>;
  }
  return (
    <div className="mc-slots">
      {slots.map(slot => {
        const rowCls = [
          'mc-slot-row',
          slot.isSelected && 'selected',
          slot.isSoldOut && 'sold-out',
          slot.variant === 'tour' && 'lr-slot-tour',
        ].filter(Boolean).join(' ');
        return (
          <div key={slot.id} data-testid={`slot-${slot.id}`} className={rowCls} onClick={slot.isSoldOut ? undefined : slot.onClick}>
            <span className="mc-stime">{slot.time}</span>
            {Array.isArray(slot.specialHours) && slot.specialHours.length > 0 && (
              <span className="mc-sh-badges">
                {slot.specialHours.map(({ special, type }, i) => (
                  <SpecialHoursBadge key={special?.ruleId || special?.typeId || i} special={special} type={type} />
                ))}
              </span>
            )}
            {slot.urgencyPill && (
              <span className={`mc-urgency ${slot.urgencyPill.kind}`} data-testid={`urgency-${slot.id}`}>{slot.urgencyPill.label}</span>
            )}
            {!slot.urgencyPill && !slot.isSoldOut && slot.popularLabel && (
              <span className="mc-popular" data-testid={`popular-${slot.id}`}>{slot.popularLabel}</span>
            )}
            <span className="mc-sprice">{slot.priceLabel}</span>
          </div>
        );
      })}
    </div>
  );
}
